import { Component } from "@angular/core";

@Component({
  selector: 'joint-app-warning-dialog',
  templateUrl: './joint-application-warning-dialog.component.html',
  styleUrls: ['./joint-application-warning-dialog.component.css']
})
export class JointApplicationWarningDialogComponent {
  constructor(
  ) {}
}
